@import (reference) '../../../constants/spacing.module.less';

.labsPageContent {
  max-width: 1200px;

  .warningBannerContainer {
    max-width: 858px;
  }

  .refreshIndicator {
    opacity: 0.7;
    color: var(--grey--900);
    font-style: italic;
    height: 40px;
    margin-left: @space-32;
  }
}
